import { ClientsContext } from "context/ClientsContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useClients = () => {
  return useProviderInitializedContext(ClientsContext);
};
